module.exports = __webpack_public_path__ + "img/void-chart-dropdown.07b486d8.gif";